import { Link } from "react-router-dom"
import Button from "../../components/ui/Button"
import Title from "../../components/ui/Title"
import '../../styles/pages/system.scss'

const Shops = () => {
    return (
        <div className="page-container">
            <div className="line-container">
            <Title
                text="System"
                size="full"
            />
            <header className="system-header">
                <h1 className="system-title">
                    Enhance your equipment and get rare items!
                </h1>
                <p>
                    Crossbell City is home to a vast number of different shops and businesses, many of which will be able to support the SSS in their duties.
                </p>
            </header>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Guillaume Factory
                    </h1>
                    <p>
                        The SSS can enhance their weapons and armor at Guillaume Factory, run by its namesake, Guillaume, in Crossbell City's Downtown District. If you have the necessary mira and materials, you can modify your equipment into special gear that isn't available at normal shops.
                        <br/>
                        *Modified equipment will typically not only have increased stats, but also additional effects added to it.
                        </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/equip-1.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Neinvalli Exchange
                    </h1>
                    <p>
                        At the exchange shop known as Neinvalli Exchange in the Downtown District, you will be able to trade certain items for rare equipment and quartz that you can't find anywhere else.
                    </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/equip-2.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <Link to="/system">
                <Button
                    text="Go Back"
                    type="solid"
                />
            </Link>
            </div>
        </div>
    )
}

export default Shops